var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"x-checkbox",attrs:{"data-help":_vm.computedHelp}},[_c('v-checkbox',{attrs:{"input-value":_vm.value,"label":_vm.label,"disabled":_vm.disabled,"hide-details":"auto"},on:{"change":function($event){return _vm.$emit('input', $event)}}}),_c('HelpButton',{attrs:{"id":_vm.id,"help":_vm.computedHelp}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }